'use strict';

var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageForTagBCP47 = exports.getLanguageForCountry = exports.getLanguageIso6392 = exports.getLocale = exports.getLanguageTagBCP47 = exports.getLanguageIso6391 = exports.UnicodeBCP47LocaleIdentifier = exports.Language6392 = exports.Language6391 = void 0;
var language_1 = require("@gig/magic-sdk/dist/adapter/users/language");
var getCountries_1 = require("@gig/magic-sdk/dist/adapter/users/getCountries");
var Language6391;
(function (Language6391) {
    Language6391["ENGLISH"] = "en";
    Language6391["SWEDISH"] = "sw";
    Language6391["FINNISH"] = "fi";
    Language6391["GERMAN"] = "de";
    Language6391["NORWEGIAN"] = "no";
    Language6391["DUTCH"] = "nl";
    Language6391["TURKISH"] = "tr";
    Language6391["DANISH"] = "da";
    Language6391["LATVIAN"] = "lv";
    Language6391["RUSSIAN"] = "ru";
    Language6391["SPANISH"] = "es";
    Language6391["MACEDONIAN"] = "mk";
    Language6391["HUNGARIAN"] = "hu";
    Language6391["FRENCH"] = "fr";
    Language6391["JAPANESE"] = "ja";
    Language6391["HINDI"] = "hi";
    Language6391["THAI"] = "th";
    Language6391["ROMANIAN"] = "ro";
    Language6391["MANDARIN"] = "zh";
    Language6391["PORTUGUESE"] = "pt";
    Language6391["ESTONIAN"] = "et";
    Language6391["IRISH"] = "en";
})(Language6391 = exports.Language6391 || (exports.Language6391 = {}));
var Language6392;
(function (Language6392) {
    Language6392["ENGLISH"] = "eng";
    Language6392["SWEDISH"] = "swe";
    Language6392["FINNISH"] = "fin";
    Language6392["GERMAN"] = "deu";
    Language6392["NORWEGIAN"] = "nor";
    Language6392["DUTCH"] = "nld";
    Language6392["TURKISH"] = "tur";
    Language6392["DANISH"] = "dan";
    Language6392["BRITISH"] = "eng";
    Language6392["AUSTRALIAN"] = "aus";
    Language6392["CANADIAN"] = "eng";
    Language6392["NEW_ZEALAND"] = "eng";
    Language6392["LATVIAN"] = "lav";
    Language6392["RUSSIAN"] = "rus";
    Language6392["SPANISH"] = "spa";
    Language6392["MACEDONIAN"] = "mkd";
    Language6392["HUNGARIAN"] = "hun";
    Language6392["CANADIAN_FRENCH"] = "fra";
    Language6392["JAPANESE"] = "jpn";
    Language6392["HINDI"] = "hin";
    Language6392["THAI"] = "tha";
    Language6392["ARGENTINE_SPANISH"] = "spa";
    Language6392["ROMANIAN"] = "ron";
    Language6392["SOUTH_AFRICAN"] = "zaf";
    Language6392["CHILEAN"] = "chl";
    Language6392["MANDARIN"] = "cmn";
    Language6392["PERU"] = "per";
    Language6392["BRAZILIAN_PORTUGUESE"] = "bpt";
    Language6392["ESTONIAN"] = "est";
    Language6392["IRISH"] = "eng";
    Language6392["AMERICAN_ENGLISH"] = "eng";
})(Language6392 = exports.Language6392 || (exports.Language6392 = {}));
var UnicodeBCP47LocaleIdentifier;
(function (UnicodeBCP47LocaleIdentifier) {
    UnicodeBCP47LocaleIdentifier["ENGLISH"] = "en";
    UnicodeBCP47LocaleIdentifier["SWEDISH"] = "sv-SE";
    UnicodeBCP47LocaleIdentifier["FINNISH"] = "fi-FI";
    UnicodeBCP47LocaleIdentifier["GERMAN"] = "de-DE";
    UnicodeBCP47LocaleIdentifier["NORWEGIAN"] = "no-NO";
    UnicodeBCP47LocaleIdentifier["DUTCH"] = "nl-NL";
    UnicodeBCP47LocaleIdentifier["TURKISH"] = "tr-TR";
    UnicodeBCP47LocaleIdentifier["DANISH"] = "da-DK";
    UnicodeBCP47LocaleIdentifier["BRITISH"] = "en-GB";
    UnicodeBCP47LocaleIdentifier["AUSTRALIAN"] = "en-AU";
    UnicodeBCP47LocaleIdentifier["CANADIAN"] = "en-CA";
    UnicodeBCP47LocaleIdentifier["NEW_ZEALAND"] = "en-NZ";
    UnicodeBCP47LocaleIdentifier["LATVIAN"] = "lv-LV";
    UnicodeBCP47LocaleIdentifier["RUSSIAN"] = "ru-RU";
    UnicodeBCP47LocaleIdentifier["SPANISH"] = "es-ES";
    UnicodeBCP47LocaleIdentifier["MACEDONIAN"] = "mk-MK";
    UnicodeBCP47LocaleIdentifier["HUNGARIAN"] = "hu-HU";
    UnicodeBCP47LocaleIdentifier["CANADIAN_FRENCH"] = "fr-CA";
    UnicodeBCP47LocaleIdentifier["JAPANESE"] = "ja-JP";
    UnicodeBCP47LocaleIdentifier["HINDI"] = "hi-IN";
    UnicodeBCP47LocaleIdentifier["THAI"] = "th-TH";
    UnicodeBCP47LocaleIdentifier["ARGENTINE_SPANISH"] = "es-AR";
    UnicodeBCP47LocaleIdentifier["ROMANIAN"] = "ro-RO";
    UnicodeBCP47LocaleIdentifier["SOUTH_AFRICAN"] = "en-ZA";
    UnicodeBCP47LocaleIdentifier["CHILEAN"] = "es-CL";
    UnicodeBCP47LocaleIdentifier["MANDARIN"] = "zh-CN";
    UnicodeBCP47LocaleIdentifier["PERU"] = "es-PE";
    UnicodeBCP47LocaleIdentifier["BRAZILIAN_PORTUGUESE"] = "pt-BR";
    UnicodeBCP47LocaleIdentifier["ESTONIAN"] = "et-EE";
    UnicodeBCP47LocaleIdentifier["IRISH"] = "en-IE";
    UnicodeBCP47LocaleIdentifier["AMERICAN_ENGLISH"] = "en-US";
})(UnicodeBCP47LocaleIdentifier = exports.UnicodeBCP47LocaleIdentifier || (exports.UnicodeBCP47LocaleIdentifier = {}));
var iso6392Map = (_a = {},
    _a[language_1.Language.ENGLISH] = Language6392.ENGLISH,
    _a[language_1.Language.SWEDISH] = Language6392.SWEDISH,
    _a[language_1.Language.FINNISH] = Language6392.FINNISH,
    _a[language_1.Language.GERMAN] = Language6392.GERMAN,
    _a[language_1.Language.NORWEGIAN] = Language6392.NORWEGIAN,
    _a[language_1.Language.DUTCH] = Language6392.DUTCH,
    _a[language_1.Language.BRITISH] = Language6392.BRITISH,
    _a[language_1.Language.TURKISH] = Language6392.TURKISH,
    _a[language_1.Language.DANISH] = Language6392.DANISH,
    _a[language_1.Language.AUSTRALIAN] = Language6392.AUSTRALIAN,
    _a[language_1.Language.CANADIAN] = Language6392.CANADIAN,
    _a[language_1.Language.NEW_ZEALAND] = Language6392.NEW_ZEALAND,
    _a[language_1.Language.LATVIAN] = Language6392.LATVIAN,
    _a[language_1.Language.RUSSIAN] = Language6392.RUSSIAN,
    _a[language_1.Language.SPANISH] = Language6392.SPANISH,
    _a[language_1.Language.MACEDONIAN] = Language6392.MACEDONIAN,
    _a[language_1.Language.HUNGARIAN] = Language6392.HUNGARIAN,
    _a[language_1.Language.CANADIAN_FRENCH] = Language6392.CANADIAN_FRENCH,
    _a[language_1.Language.JAPANESE] = Language6392.JAPANESE,
    _a[language_1.Language.HINDI] = Language6392.HINDI,
    _a[language_1.Language.THAI] = Language6392.THAI,
    _a[language_1.Language.ARGENTINE_SPANISH] = Language6392.ARGENTINE_SPANISH,
    _a[language_1.Language.ROMANIAN] = Language6392.ROMANIAN,
    _a[language_1.Language.SOUTH_AFRICAN] = Language6392.SOUTH_AFRICAN,
    _a[language_1.Language.CHILEAN] = Language6392.CHILEAN,
    _a[language_1.Language.MANDARIN] = Language6392.MANDARIN,
    _a[language_1.Language.PERU] = Language6392.PERU,
    _a[language_1.Language.BRAZILIAN_PORTUGUESE] = Language6392.BRAZILIAN_PORTUGUESE,
    _a[language_1.Language.ESTONIAN] = Language6392.ESTONIAN,
    _a[language_1.Language.IRISH] = Language6392.IRISH,
    _a[language_1.Language.AMERICAN_ENGLISH] = Language6392.AMERICAN_ENGLISH,
    _a);
var countryLanguageMap = (_b = {},
    _b[getCountries_1.Country.AUSTRIA] = language_1.Language.GERMAN,
    _b[getCountries_1.Country.GERMANY] = language_1.Language.GERMAN,
    _b[getCountries_1.Country.SWEDEN] = language_1.Language.SWEDISH,
    _b[getCountries_1.Country.NORWAY] = language_1.Language.NORWEGIAN,
    _b[getCountries_1.Country.FINLAND] = language_1.Language.FINNISH,
    _b[getCountries_1.Country.NEW_ZEALAND] = language_1.Language.NEW_ZEALAND,
    _b[getCountries_1.Country.DENMARK] = language_1.Language.DANISH,
    _b[getCountries_1.Country.UNITED_KINGDOM] = language_1.Language.BRITISH,
    _b[getCountries_1.Country.NETHERLANDS] = language_1.Language.DUTCH,
    _b[getCountries_1.Country.CANADA] = language_1.Language.CANADIAN,
    _b[getCountries_1.Country.LATVIA] = language_1.Language.LATVIAN,
    _b[getCountries_1.Country.RUSSIA] = language_1.Language.RUSSIAN,
    _b[getCountries_1.Country.MACEDONIA] = language_1.Language.MACEDONIAN,
    _b[getCountries_1.Country.SPAIN] = language_1.Language.SPANISH,
    _b[getCountries_1.Country.HUNGARY] = language_1.Language.HUNGARIAN,
    _b[getCountries_1.Country.JAPAN] = language_1.Language.JAPANESE,
    _b[getCountries_1.Country.INDIA] = language_1.Language.HINDI,
    _b[getCountries_1.Country.THAILAND] = language_1.Language.THAI,
    _b[getCountries_1.Country.ARGENTINA] = language_1.Language.ARGENTINE_SPANISH,
    _b[getCountries_1.Country.ROMANIA] = language_1.Language.ROMANIAN,
    _b[getCountries_1.Country.SOUTH_AFRICA] = language_1.Language.SOUTH_AFRICAN,
    _b[getCountries_1.Country.CHILE] = language_1.Language.CHILEAN,
    _b[getCountries_1.Country.SRI_LANKA] = language_1.Language.MANDARIN,
    _b[getCountries_1.Country.PERU] = language_1.Language.PERU,
    _b[getCountries_1.Country.BRAZIL] = language_1.Language.BRAZILIAN_PORTUGUESE,
    _b[getCountries_1.Country.ESTONIA] = language_1.Language.ESTONIAN,
    _b[getCountries_1.Country.IRELAND] = language_1.Language.IRISH,
    _b);
var iso6391Map = (_c = {},
    _c[language_1.Language.ENGLISH] = Language6391.ENGLISH,
    _c[language_1.Language.SWEDISH] = Language6391.SWEDISH,
    _c[language_1.Language.FINNISH] = Language6391.FINNISH,
    _c[language_1.Language.GERMAN] = Language6391.GERMAN,
    _c[language_1.Language.NORWEGIAN] = Language6391.NORWEGIAN,
    _c[language_1.Language.DUTCH] = Language6391.DUTCH,
    _c[language_1.Language.BRITISH] = Language6391.ENGLISH,
    _c[language_1.Language.TURKISH] = Language6391.TURKISH,
    _c[language_1.Language.DANISH] = Language6391.DANISH,
    _c[language_1.Language.AUSTRALIAN] = Language6391.ENGLISH,
    _c[language_1.Language.CANADIAN] = Language6391.ENGLISH,
    _c[language_1.Language.NEW_ZEALAND] = Language6391.ENGLISH,
    _c[language_1.Language.LATVIAN] = Language6391.LATVIAN,
    _c[language_1.Language.RUSSIAN] = Language6391.RUSSIAN,
    _c[language_1.Language.SPANISH] = Language6391.SPANISH,
    _c[language_1.Language.MACEDONIAN] = Language6391.MACEDONIAN,
    _c[language_1.Language.HUNGARIAN] = Language6391.HUNGARIAN,
    _c[language_1.Language.CANADIAN_FRENCH] = Language6391.FRENCH,
    _c[language_1.Language.JAPANESE] = Language6391.JAPANESE,
    _c[language_1.Language.HINDI] = Language6391.HINDI,
    _c[language_1.Language.THAI] = Language6391.THAI,
    _c[language_1.Language.ARGENTINE_SPANISH] = Language6391.SPANISH,
    _c[language_1.Language.ROMANIAN] = Language6391.ROMANIAN,
    _c[language_1.Language.SOUTH_AFRICAN] = Language6391.ENGLISH,
    _c[language_1.Language.CHILEAN] = Language6391.SPANISH,
    _c[language_1.Language.MANDARIN] = Language6391.MANDARIN,
    _c[language_1.Language.PERU] = Language6391.SPANISH,
    _c[language_1.Language.BRAZILIAN_PORTUGUESE] = Language6391.PORTUGUESE,
    _c[language_1.Language.ESTONIAN] = Language6391.ESTONIAN,
    _c[language_1.Language.IRISH] = Language6391.IRISH,
    _c[language_1.Language.AMERICAN_ENGLISH] = Language6391.ENGLISH,
    _c);
var languageTagBCP47 = (_d = {},
    _d[language_1.Language.CANADIAN] = UnicodeBCP47LocaleIdentifier.CANADIAN,
    _d[language_1.Language.CANADIAN_FRENCH] = UnicodeBCP47LocaleIdentifier.CANADIAN_FRENCH,
    _d[language_1.Language.ENGLISH] = UnicodeBCP47LocaleIdentifier.ENGLISH,
    _d[language_1.Language.SWEDISH] = UnicodeBCP47LocaleIdentifier.SWEDISH,
    _d[language_1.Language.GERMAN] = UnicodeBCP47LocaleIdentifier.GERMAN,
    _d[language_1.Language.NORWEGIAN] = UnicodeBCP47LocaleIdentifier.NORWEGIAN,
    _d[language_1.Language.DUTCH] = UnicodeBCP47LocaleIdentifier.DUTCH,
    _d[language_1.Language.TURKISH] = UnicodeBCP47LocaleIdentifier.TURKISH,
    _d[language_1.Language.DANISH] = UnicodeBCP47LocaleIdentifier.DANISH,
    _d[language_1.Language.BRITISH] = UnicodeBCP47LocaleIdentifier.BRITISH,
    _d[language_1.Language.AUSTRALIAN] = UnicodeBCP47LocaleIdentifier.AUSTRALIAN,
    _d[language_1.Language.NEW_ZEALAND] = UnicodeBCP47LocaleIdentifier.NEW_ZEALAND,
    _d[language_1.Language.RUSSIAN] = UnicodeBCP47LocaleIdentifier.RUSSIAN,
    _d[language_1.Language.LATVIAN] = UnicodeBCP47LocaleIdentifier.LATVIAN,
    _d[language_1.Language.SPANISH] = UnicodeBCP47LocaleIdentifier.SPANISH,
    _d[language_1.Language.MACEDONIAN] = UnicodeBCP47LocaleIdentifier.MACEDONIAN,
    _d[language_1.Language.HUNGARIAN] = UnicodeBCP47LocaleIdentifier.HUNGARIAN,
    _d[language_1.Language.JAPANESE] = UnicodeBCP47LocaleIdentifier.JAPANESE,
    _d[language_1.Language.HINDI] = UnicodeBCP47LocaleIdentifier.HINDI,
    _d[language_1.Language.FINNISH] = UnicodeBCP47LocaleIdentifier.FINNISH,
    _d[language_1.Language.THAI] = UnicodeBCP47LocaleIdentifier.THAI,
    _d[language_1.Language.ARGENTINE_SPANISH] = UnicodeBCP47LocaleIdentifier.ARGENTINE_SPANISH,
    _d[language_1.Language.ROMANIAN] = UnicodeBCP47LocaleIdentifier.ROMANIAN,
    _d[language_1.Language.SOUTH_AFRICAN] = UnicodeBCP47LocaleIdentifier.SOUTH_AFRICAN,
    _d[language_1.Language.CHILEAN] = UnicodeBCP47LocaleIdentifier.CHILEAN,
    _d[language_1.Language.MANDARIN] = UnicodeBCP47LocaleIdentifier.MANDARIN,
    _d[language_1.Language.PERU] = UnicodeBCP47LocaleIdentifier.PERU,
    _d[language_1.Language.BRAZILIAN_PORTUGUESE] = UnicodeBCP47LocaleIdentifier.BRAZILIAN_PORTUGUESE,
    _d[language_1.Language.ESTONIAN] = UnicodeBCP47LocaleIdentifier.ESTONIAN,
    _d[language_1.Language.IRISH] = UnicodeBCP47LocaleIdentifier.IRISH,
    _d[language_1.Language.AMERICAN_ENGLISH] = UnicodeBCP47LocaleIdentifier.AMERICAN_ENGLISH,
    _d);
var getLanguageIso6391 = function (language) {
    return iso6391Map[language];
};
exports.getLanguageIso6391 = getLanguageIso6391;
var getLanguageTagBCP47 = function (language) { return languageTagBCP47[language]; };
exports.getLanguageTagBCP47 = getLanguageTagBCP47;
var getLocale = function (language, country) {
    return language.toLowerCase() + "_" + country.toUpperCase();
};
exports.getLocale = getLocale;
var getLanguageIso6392 = function (language) {
    return iso6392Map[language];
};
exports.getLanguageIso6392 = getLanguageIso6392;
var getLanguageForCountry = function (country) {
    return countryLanguageMap[country] || language_1.Language.ENGLISH;
};
exports.getLanguageForCountry = getLanguageForCountry;
var getLanguageForTagBCP47 = function (locale) {
    return (Object.values(language_1.Language).find(function (language) { return exports.getLanguageTagBCP47(language) === locale; }) || language_1.Language.ENGLISH);
};
exports.getLanguageForTagBCP47 = getLanguageForTagBCP47;
